import { render } from "./runningIndexComponent.vue?vue&type=template&id=39e2dc00"
import script from "./runningIndexComponent.vue?vue&type=script&lang=js"
export * from "./runningIndexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__